module.exports = __webpack_public_path__ + "img/16.3d969b54.png";